<template>
  <v-container fill-height class="py-16">
  <v-dialog v-model="dialog" persistent scrollable :max-width="noticeWidth">
    <v-card outlined height="82vh">
      <v-card-title class="bg_dark dw_green--text font-weight-light">
        <v-icon v-text="mdiFileDocumentOutline" color="dw_green" class="mr-2" />
        Terms of Use
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <h1 class="text-h6 font-weight-regular orange--text">Warning!!</h1>
        <p class="body-2 font-weight-light">
          You are accessing a prototype application containing Dark Wolf Solutions, LLC proprietary
          information and content. By accessing this application and its content you agree to the
          following terms of use outlined below.
        </p>
        <p class="body-2 font-weight-light">
          This application includes data that shall not be disclosed outside of Dark Wolf Solutions,
          LLC and shall not be duplicated, used, reverse-engineered, or disclosed — in whole or in
          part — for any purpose other than to evaluate this application's functionality.
        </p>
        <p class="body-2 font-weight-light">
          This application contains data sourced from MITRE's CAPEC&trade;, ATT&amp;CK&reg;, and
          CWE&trade; frameworks as well as data from NIST SP 800-53 Rev. 5. See links below for
          additional terms and conditions, trademarks, copyrights, and intellectual restrictions
          that apply upon use of this application.
        </p>
        <p class="body-2 font-weight-light dw_green--text">
          <a href="https://capec.mitre.org/about/termsofuse.html" target="__blank">
            CAPEC&trade; Attack Patterns Terms of Use
            <v-icon v-text="mdiOpenInNew" x-small class="ml-2" />
          </a>
        </p>
        <p class="body-2 font-weight-light dw_green--text">
          <a href="https://attack.mitre.org/resources/terms-of-use/" target="__blank">
            MITRE ATT&amp;CK&reg; Terms of Use
            <v-icon v-text="mdiOpenInNew" x-small class="ml-2" />
          </a>
        </p>
        <p class="body-2 font-weight-light dw_green--text">
          <a
            href="https://www.nist.gov/topics/data/public-access-nist-research/copyright-fair-use-and-licensing-statements-srd-data-and"
            target="__blank">
            NIST SP 800-53 Fair Use
            <v-icon v-text="mdiOpenInNew" x-small class="ml-2" />
          </a>
        </p>
        <p class="body-2 font-weight-light dw_green--text">
          <a href="https://cwe.mitre.org/about/termsofuse.html" target="__blank">
            CWE&trade; Weaknesses Terms of Use
            <v-icon v-text="mdiOpenInNew" x-small class="ml-2" />
          </a>
        </p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="dw_green" text @click="acceptToU">Accept</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { mdiFileDocumentOutline, mdiOpenInNew } from '@mdi/js';

export default {
  name: 'termsOfUse',
  data() {
    return {
      mdiFileDocumentOutline,
      mdiOpenInNew,
      dialog: true,
      noticeWidth: '38vw'
    };
  },
  watch: {
    '$vuetify.breakpoint.name': {
      handler(name) {
        if (name === 'xs' || name === 'sm') {
          this.noticeWidth = '80vw';
        } else {
          this.noticeWidth = '38vw';
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations([
      'setLayout'
    ]),
    acceptToU() {
      this.setLayout('default-layout');
      this.$router.push({ name: 'playbook' });
    }
  }
};
</script>
